import React, { Component } from 'react';
import { arrayOf, func, number, shape, string } from 'prop-types';
import SetRangeValueInput from './SetRangeValueInput/SetRangeValueInput';
import SetElementDropdown from './SetElementDropdown/SetElementDropdown';
import SetPercentInput from './SetPercentInput/SetPercentInput';
import './SettingsSection.scss';

class SettingsSection extends Component {
  static propTypes = {
    displayValue: string,
    marketElements: arrayOf(
      shape({
        field_title: string,
        source_field: string
      })
    ),
    percent: number,
    rangeInputValue: number,
    roundTo: number,
    section: string,
    setElementValue: func,
    setProposedRangeValue: func,
    setTempProposedRangeValue: func,
    setRangePctValue: func,
    tempValue: string
  };

  render() {
    const {
      displayValue,
      marketElements,
      percent,
      rangeInputValue,
      roundTo,
      section,
      setElementValue,
      setProposedRangeValue,
      setTempProposedRangeValue,
      setRangePctValue,
      tempValue,
      isDisabled
    } = this.props;

    const sectionTitle = section.charAt(0).toUpperCase() + section.slice(1);

    return (
      <div className={`${section}__range-settings`}>
        <div className="range__row range__row-header">
          <span className="pxl-header-xxsmall">{sectionTitle}</span>
          <div className="line" />
        </div>
        <div className="range__row">
          <SetPercentInput
            column={section}
            percent={percent}
            setRangePctValue={setRangePctValue}
            isDisabled={isDisabled}
          />
          <span className="input__spacer">of</span>
          <SetElementDropdown
            column={section}
            marketElements={marketElements}
            setElementValue={setElementValue}
            value={displayValue}
          />
        </div>
        <div className="range__row range__row-right">
          <span className="input__spacer">=</span>
          <SetRangeValueInput
            column={section}
            roundTo={roundTo}
            setProposedRangeValue={setProposedRangeValue}
            setTempProposedRangeValue={setTempProposedRangeValue}
            tempValue={tempValue}
            value={rangeInputValue.toString()}
            isDisabled={isDisabled}
          />
        </div>
      </div>
    );
  }
}

export default SettingsSection;
